import React from 'react';

export const DropdownClose = () => {
  return (
    <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.9134 0.263158L10.7383 0.0873065C10.6225 -0.0291022 10.4351 -0.0291022 10.3192 0.0873065L5.50139 4.92941L0.681124 0.0873065C0.56524 -0.0291022 0.377854 -0.0291022 0.261971 0.0873065L0.0869126 0.263158C-0.0289709 0.379567 -0.0289709 0.567802 0.0869126 0.684211L5.28934 5.91269C5.40523 6.0291 5.59261 6.0291 5.7085 5.91269L10.9109 0.684211C11.0293 0.567802 11.0293 0.379567 10.9134 0.263158Z"
        fill="#F32645"
      />
    </svg>
  );
};
